<template>
    <div class="container-fluid">
        <div class="row">
            <div class="mt-0">
                <div class="row" id="lower-div">
                    <div class="card mt-3">
                        <div class="card-body p-3">
                            <div class="requests-filter-card p-3 mb-3" v-show="showFilter">
                                <div class="filter-panel">
                                    <!-- Status -->
                                    <div class="filter-item">
                                        <label class="form-label">Status</label>
                                        <el-radio-group v-model="status" size="default" class="status-segmented-group">
                                            <el-radio-button value="0">Bütün</el-radio-button>
                                            <el-radio-button value="1">Yeni</el-radio-button>
                                            <el-radio-button value="4">İcrahatda</el-radio-button>
                                            <el-radio-button value="2">Təsdiq</el-radio-button>
                                            <el-radio-button value="3">İmtina</el-radio-button>
                                        </el-radio-group>
                                    </div>

                                    <!-- ReqType -->
                                    <div class="filter-item">
                                        <label class="form-label">Sorğu növü</label>
                                        <el-select v-model="reqId" class="filter-select" collapse-tags collapse-tags-tooltip placeholder="Seçin" size="default">
                                            <el-option label="Bütün" :value="-1" />
                                            <el-option label="Ərizə təsdiqləmə" :value="0" />
                                            <el-option label="Digər məlumatların dəyişdirilməsi" :value="1" />
                                            <el-option label="Konvertasiya" :value="2" />
                                            <el-option label="Kredit xəttinin ayrılması" :value="3" />
                                            <el-option label="Ödənişin alınması" :value="4" />
                                            <el-option label="Müqavilə müddətinin dəyişdirilməsi" :value="5" />
                                            <el-option label="Sığorta haqqının dəyişdirilməsi" :value="6" />
                                            <el-option label="Bir aylıq sığorta haqqının dəyişdirilməsi" :value="7" />
                                            <el-option label="Müqavilənin bərpası" :value="8" />
                                            <el-option label="Müqavilənin dondurulması" :value="9" />
                                            <el-option label="Müqaviləyə xitam verilməsi" :value="10" />
                                        </el-select>
                                    </div>

                                    <!-- Dates -->
                                    <div class="filter-item">
                                        <label class="form-label">Tarix</label>
                                        <div class="date-range d-flex align-items-center gap-2">
                                            <el-date-picker format="DD.MM.YYYY" :disabled-date="DisableStartDate"
                                                v-model="date1" type="date" class="filter-date-picker" size="default"/>
                                            <span class="date-separator text-muted">—</span>
                                            <el-date-picker format="DD.MM.YYYY" :disabled-date="DisableEndDate"
                                                v-model="date2" type="date" class="filter-date-picker" size="default"/>
                                        </div>
                                    </div>

                                    <!-- Search -->
                                    <div class="filter-item filter-item--grow" style="align-self: flex-end;">
                                        <div class="app-search-form-group">
                                            <el-input
                                                v-model="srcText"
                                                class="app-search-input"
                                                placeholder="Tam adı / FIN / Ərizə nömrəsi"
                                                clearable
                                                @keydown.enter="GetQuotas()"
                                            >
                                                <template #prefix>
                                                    <i class="bi bi-search search-prefix-icon"></i>
                                                </template>
                                            </el-input>
                                            <button type="button" @click="GetQuotas()" class="btn app-search-btn">
                                                <i class="bi bi-search"></i>
                                                <span>Axtar</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-loading="loading">
                                <Table @get-data="GetQuotas" :data="data2" :showFilter="showFilter"></Table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import dayjs from "dayjs";
import Table from "./Components/Table.vue";
export default {
    components: {
        Table
    },
    data() {
        return {
            srcText: null,
            loading: null,
            data: [],
            data2: [],
            dialogVis: false,
            status: "0",
            reqId: -1,
            date1: new Date(new Date().setFullYear(new Date().getFullYear() - 2)).toISOString().split("T")[0],
            date2: new Date(),
            showFilter: true,
            companyName: null
        }
    },
    methods: {
        DisableStartDate(date) {
            return this.date2 && dayjs(date).isAfter(dayjs(this.date2), 'day')
        },
        DisableEndDate(date) {
            return this.date1 && dayjs(date).isBefore(dayjs(this.date1), 'day')
        },
        NewQuota() {
            window.open(window.location.origin + '/underwriting/quota', "_blank");
        },
        GetQuotas() {
            this.data = [
                {
                    quotaId: 1,
                    respPerson: "Emil Rızaev",
                    reqType: "Ərizə təstiqləmə",
                    quotaFullNumber: "Q-2025-001",
                    statusId: 2,
                    quotaStatusName: "Təstiq",
                    quotaDateStr: "16.08.2025",
                    insured: { name: "ABC Şirkəti" },
                    insuredPerson: { name: "Elvin Əliyev" },
                    insuredCount: 25,
                    payType: "Aylıq",
                    currency: "AZN",
                    period: 36,
                    created: "16.08.2025 10:00",
                    updated: "16.08.2025 12:30"
                },
                {
                    quotaId: 2,
                    reqType: "Ərizə təstiqləmə",
                    respPerson: "Emil Rızaev",
                    quotaFullNumber: "Q-2025-002",
                    statusId: 1,
                    quotaStatusName: "Yeni",
                    quotaDateStr: "15.08.2025",
                    insured: { name: "XYZ MMC" },
                    insuredPerson: { name: "Murad Həsənov" },
                    insuredCount: 15,
                    period: 48,
                    payType: "Aylıq",
                    currency: "AZN",
                    created: "15.08.2025 09:20",
                    updated: "15.08.2025 11:45"
                },
                {
                    quotaId: 3,
                    reqType: "Müqavilənin bərpası",
                    quotaFullNumber: "Q-2025-003",
                    respPerson: "Emil Rızaev",
                    statusId: 3,
                    quotaStatusName: "İmtina",
                    quotaDateStr: "14.08.2025",
                    insured: { name: "Delta Ltd." },
                    insuredPerson: { name: "Leyla Məmmədova" },
                    insuredCount: 40,
                    payType: "Aylıq",
                    currency: "AZN",
                    period: 48,
                    created: "14.08.2025 08:10",
                    updated: "14.08.2025 10:00"
                },
                {
                    quotaId: 4,
                    quotaFullNumber: "Q-2025-004",
                    respPerson: "Emil Rızaev",
                    reqType: "Siğorta haqqının dəyişdirilməsi",
                    statusId: 4,
                    quotaStatusName: "İcrahatda",
                    quotaDateStr: "13.08.2025",
                    insured: { name: "Gamma Corp." },
                    insuredPerson: { name: "Elvin Bayramov" },
                    insuredCount: 30,
                    period: 36,
                    payType: "Birdəfəlik",
                    currency: "USD",
                    created: "13.08.2025 14:15",
                    updated: "13.08.2025 16:50"
                },
                {
                    quotaId: 5,
                    quotaFullNumber: "Q-2025-005",
                    reqType: "Konvertasiya",
                    respPerson: "Emil Rızaev",
                    statusId: 1,
                    quotaStatusName: "Yeni",
                    quotaDateStr: "12.08.2025",
                    insured: { name: "Beta Holding" },
                    insuredPerson: { name: "Rıza Xanlı" },
                    insuredCount: 50,
                    payType: "Aylıq",
                    currency: "EUR",
                    period: 36,
                    created: "12.08.2025 11:30",
                    updated: "12.08.2025 13:00"
                },
                {
                    quotaId: 6,
                    quotaFullNumber: "Q-2025-006",
                    reqType: "Ərizə təstiqləmə",
                    respPerson: "Emil Rızaev",
                    statusId: 1,
                    quotaStatusName: "Yeni",
                    quotaDateStr: "11.08.2025",
                    insured: { name: "Omega Bank" },
                    insuredPerson: { name: "Samir Quliyev" },
                    insuredCount: 20,
                    payType: "Aylıq",
                    currency: "AZN",
                    period: 24,
                    created: "11.08.2025 10:40",
                    updated: "11.08.2025 12:10"
                },
                {
                    quotaId: 7,
                    quotaFullNumber: "Q-2025-007",
                    reqType: "Müqavilənin bərpası",
                    respPerson: "Sevda Babeva",
                    statusId: 2,
                    quotaStatusName: "Təstiq",
                    quotaDateStr: "10.08.2025",
                    insured: { name: "Sigma LLC" },
                    insuredPerson: { name: "Aysel Məlikova" },
                    insuredCount: 60,
                    payType: "Birdəfəlik",
                    currency: "USD",
                    period: 12,
                    created: "10.08.2025 09:15",
                    updated: "10.08.2025 11:25"
                },
                {
                    quotaId: 8,
                    quotaFullNumber: "Q-2025-008",
                    reqType: "Siğorta haqqının dəyişdirilməsi",
                    statusId: 3,
                    respPerson: "Sevda Babeva",
                    quotaStatusName: "İmtina",
                    quotaDateStr: "09.08.2025",
                    insured: { name: "Orion Group" },
                    insuredPerson: { name: "Nigar Qasımova" },
                    insuredCount: 35,
                    payType: "Aylıq",
                    currency: "AZN",
                    period: 60,
                    created: "09.08.2025 08:30",
                    updated: "09.08.2025 10:00"
                },
                {
                    quotaId: 9,
                    quotaFullNumber: "Q-2025-009",
                    respPerson: "Sevda Babeva",
                    reqType: "Konvertasiya",
                    statusId: 4,
                    quotaStatusName: "İcrahatda",
                    quotaDateStr: "08.08.2025",
                    insured: { name: "NovaTech" },
                    insuredPerson: { name: "Kamal Rəhimli" },
                    insuredCount: 45,
                    payType: "Aylıq",
                    currency: "EUR",
                    period: 36,
                    created: "08.08.2025 13:50",
                    updated: "08.08.2025 15:20"
                },
                {
                    quotaId: 10,
                    quotaFullNumber: "Q-2025-010",
                    respPerson: "Sevda Babeva",
                    reqType: "Ərizə təstiqləmə",
                    statusId: 2,
                    quotaStatusName: "Təstiq",
                    quotaDateStr: "07.08.2025",
                    insured: { name: "Atlas MMC" },
                    insuredPerson: { name: "Eldar Hüseynov" },
                    insuredCount: 28,
                    payType: "Birdəfəlik",
                    currency: "AZN",
                    period: 18,
                    created: "07.08.2025 09:00",
                    updated: "07.08.2025 10:30"
                }
            ];
            this.data2 = this.data
        }
    },
    watch: {
        status() {
            if (this.status != "0") {
                this.data2 = this.data.filter(q => q.statusId === Number(this.status));
            } else {
                this.data2 = this.data
            }
        }
    },
    mounted() {
        this.GetQuotas()
    }
}
</script>
<style scoped lang="scss">
.requests-filter-card {
    background: var(--app-surface-soft, #f8fafc);
    border: 1px solid var(--app-border, #e2e8f0);
    border-radius: var(--app-radius, 12px);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.filter-panel {
    display: flex;
    flex-wrap: wrap;
    gap: 1.15rem;
    align-items: flex-end;
}

.filter-item {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;

    .form-label {
        font-size: 0.78rem;
        font-weight: 600;
        text-transform: none;
        letter-spacing: 0.01em;
        color: var(--app-heading, #1e293b);
        margin: 0;
    }
}

.search-box {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 32px;
}

.filter-select {
    width: 210px !important;
}

.filter-date-picker {
    width: 140px !important;
}

.date-separator {
    font-size: 0.85rem;
    opacity: 0.5;
}

.filter-search-input {
    width: 250px !important;

    :deep(.el-input__wrapper) {
        height: 32px !important;
        border-radius: 6px !important;
        box-shadow: 0 0 0 1px var(--app-border, #e2e8f0) inset !important;

        &.is-focus {
            box-shadow: 0 0 0 1.5px var(--bs-info, #0b4f9c) inset !important;
        }
    }

    :deep(.search-prefix-icon) {
        font-size: 0.85rem;
        color: var(--app-text-muted, #94a3b8);
        margin-right: 2px;
    }
}

.search-action-btn {
    white-space: nowrap;
    height: 32px !important;
    min-height: 32px !important;
    max-height: 32px !important;
    line-height: 30px !important;
    padding: 0 0.95rem !important;
    font-size: 0.8125rem !important;
    font-weight: 650 !important;
    border-radius: 6px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
}

:deep(.status-segmented-group.el-radio-group) {
    background: var(--app-surface, #ffffff);
    padding: 3px;
    border-radius: 8px;
    border: 1px solid var(--app-border, #e2e8f0);

    .el-radio-button__inner {
        border: none !important;
        border-radius: 6px !important;
        padding: 6px 14px;
        font-size: 0.82rem;
        font-weight: 600;
        color: var(--app-text, #64748b);
        background: transparent !important;
        box-shadow: none !important;
        transition: all 0.15s ease;

        &:hover {
            color: var(--bs-info, #0b4f9c);
        }
    }

    .el-radio-button.is-active .el-radio-button__inner {
        background: var(--bs-info, #0b4f9c) !important;
        color: #ffffff !important;
        box-shadow: 0 2px 6px rgba(11, 79, 156, 0.25) !important;
    }
}

[data-theme="dark"] {
    .filter-item .form-label {
        color: #e2e8f0;
    }

    .filter-search-input {
        :deep(.el-input__wrapper) {
            background: #151b22 !important;
            box-shadow: 0 0 0 1px #2e3846 inset !important;

            &.is-focus {
                box-shadow: 0 0 0 1.5px #60a5fa inset !important;
            }
        }
    }

    .requests-filter-card {
        background: #182029;
        border-color: #2e3846;
    }

    :deep(.status-segmented-group.el-radio-group) {
        background: #151b22;
        border-color: #2e3846;

        .el-radio-button__inner {
            color: #94a3b8;

            &:hover {
                color: #60a5fa;
            }
        }

        .el-radio-button.is-active .el-radio-button__inner {
            background: #2563eb !important;
            color: #ffffff !important;
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.4) !important;
        }
    }
}
</style>